import { SET_TYPE_EXHIBITION } from "./actions";
import {combineReducers} from "redux";

const initialState = {
    type: 'asia'
}

const exhibitionReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_TYPE_EXHIBITION:
            return action.exhibition;
        default:
            return state;
    }
}

export const getTypeExhibition = (state) => state.type;

export default exhibitionReducer;